import { memo } from "react";

import cls from "./Overlay.module.scss";
import { classNames } from "shared/lib/classNames/classNames";

interface OverlayProps {
    className?: string;
    onClick?: () => void;
    clear?: boolean;
}

export const Overlay = memo((props: OverlayProps) => {
    const { className, onClick, clear } = props;

    return <div onClick={onClick} className={classNames(cls.overlay, { [cls.clear]: clear }, [className])} />;
});
Overlay.displayName = "Overlay";
